const state = {
    viewport: {},
};
export default function (viewport) {
    state.viewport = viewport || {};
}
export { state };
